import React from 'react'
import styled from 'styled-components'
import { ContentfulImageQueryParams } from '../../../types'

const Img = styled.img`
  width: 100%;
  height: 100%;
`

interface Props {
  src?: string | null
  preload?: boolean
  params?: ContentfulImageQueryParams
  alt: string
  className?: string
  draggable?: 'true' | 'false'
  loading?: 'eager' | 'lazy' | undefined
}

const defParams = {
  fm: 'png',
}

const Image = (props: Props) => {
  const { src, alt, className, preload = true, loading = 'lazy' } = props
  const params = { ...defParams, ...(props.params ? props.params : {}) }

  const query = Object.entries(params)
    .map(([key, val]) => `${key}=${val}`)
    .join('&')

  const resolvedSrc = src && preload ? `${src}${src.includes('?') ? '&' : '?'}${query}` : src

  return (
    <Img
      className={className}
      src={resolvedSrc || undefined}
      alt={alt}
      loading={loading}
      decoding="async"
      draggable={props.draggable}
      onDragStart={(e: React.DragEvent) => (props.draggable === 'false' ? e.preventDefault() : '')}
      referrerPolicy="origin"
    />
  )
}

export default Image
